<template>
    <span>
        <span>
            {{ formattedBytes }}
        </span>
    </span>
</template>

<script>
export default {
    name: 'BytesToUnit',
};
</script>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    bytes: {
        type: Number,
        required: true,
    },
});

const formattedBytes = computed(() => {
    return formatBytes(props.bytes);
});
function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
}
</script>
